import { AdminUsersProvider } from 'ui/admin/user-management/admin-users-context';
import { Route, Routes } from 'react-router-dom';
import { Suspense, useCallback } from 'react';
import { useLocalStorage } from '@ncc-frontend/core';
import AdminHolderPage from '../pages/admin/admin-holder-page';
import AdminUserDetailsPage from 'ui/admin/user-management/admin-user-details-page';
import AdminUsersPage from '../pages/admin/user-management/admin-users-page';
import AllocationsPage from '../pages/allocations/allocations-page';
import CoreLayout from './core-layout';
import CostLevelsPage from '../pages/admin/cost-levels/cost-levels-page';
import LoadingPage from '../pages/loading/loading-page';
import LoginPage from '../pages/login/login-page';
import MainDashboardPage from '../pages/dashboard/main-dashboard-page';

import './app-layout.scss';
import { AllocationsProvider } from 'ui/allocations/allocations-context';
import { DashboardProvider } from 'ui/dashboard/dashboard-context';
import { DataTableProvider } from 'components/data-table/data-table-context';
import { ProductReportsProvider } from 'ui/admin/product-reports/product-reports-context';
import { ProductsProvider } from 'ui/admin/products/products-context';
import ActivityGroupsPage from '../pages/admin/activity-groups/activity-groups-page';
import AllocationsPersonalContainer from 'ui/allocations/allocations-personal-container';
import ProductReportsPage from '../pages/admin/product-reports/product-reports-page';
import ProductsPage from '../pages/admin/products/product-page';
import ProtectedRoute from 'common/protected-route';
import TeamsPage from '../pages/admin/teams-page/teams-page';

function AppLayout() {
    const [collapsed, setCollapsed] = useLocalStorage<boolean>(
        'sider-collapsed',
        false
    );

    const onToggleClick = useCallback(() => {
        setCollapsed(!collapsed);
    }, [collapsed, setCollapsed]);

    return (
        <div className="flex w-screen h-screen">
            <Suspense fallback={<LoadingPage />}>
                <Routes>
                    <Route
                        element={
                            <ProtectedRoute>
                                <CoreLayout
                                    collapsed={collapsed}
                                    onToggleClick={onToggleClick}
                                />
                            </ProtectedRoute>
                        }
                    >
                        <Route
                            path="/dashboard"
                            element={
                                <AllocationsProvider>
                                    <DashboardProvider>
                                        <DataTableProvider>
                                            <MainDashboardPage
                                                collapsed={collapsed}
                                            />
                                        </DataTableProvider>
                                    </DashboardProvider>
                                </AllocationsProvider>
                            }
                        />

                        <Route
                            path="allocations"
                            element={
                                <AllocationsProvider>
                                    <AllocationsPage collapsed={collapsed} />
                                </AllocationsProvider>
                            }
                        >
                            <Route
                                path="personal"
                                element={
                                    <AllocationsProvider>
                                        <AllocationsPersonalContainer />
                                    </AllocationsProvider>
                                }
                            />
                            <Route
                                path="team"
                                element={
                                    <AllocationsProvider>
                                        <DataTableProvider>
                                            <TeamsPage></TeamsPage>
                                        </DataTableProvider>
                                    </AllocationsProvider>
                                }
                            />
                        </Route>

                        <Route
                            path="product-reports"
                            element={
                                <ProductReportsProvider>
                                    <ProductReportsPage collapsed={collapsed} />
                                </ProductReportsProvider>
                            }
                        />

                        <Route
                            path="admin"
                            element={<AdminHolderPage collapsed={collapsed} />}
                        >
                            <Route
                                path="cost-levels"
                                element={
                                    <CostLevelsPage collapsed={collapsed} />
                                }
                            />
                            <Route
                                path="products"
                                element={
                                    <ProductsProvider>
                                        <ProductsPage
                                            collapsed={collapsed}
                                        ></ProductsPage>
                                    </ProductsProvider>
                                }
                            />
                            <Route
                                path="users"
                                element={
                                    <AdminUsersProvider>
                                        <AdminUsersPage />
                                    </AdminUsersProvider>
                                }
                            />
                            <Route
                                path="users/:id"
                                element={
                                    <AdminUsersProvider>
                                        <AdminUserDetailsPage />
                                    </AdminUsersProvider>
                                }
                            />
                            <Route
                                path="activity-groups"
                                element={
                                    <ActivityGroupsPage collapsed={collapsed} />
                                }
                            />
                        </Route>
                    </Route>
                    <Route path="/" element={<LoginPage />} />
                    <Route path="login" element={<LoginPage />} />
                    <Route path="oauth2/auth" element={<LoadingPage />} />
                </Routes>
            </Suspense>
        </div>
    );
}

export default AppLayout;
